const PRIORITY_FIELDS = ['ignoreSkuList'];

const shouldSkipValue = (value) =>
  value === null ||
  value === undefined ||
  (typeof value === 'string' && value.trim() === '');

const isEmptyObject = (value) =>
  typeof value === 'object' &&
  !Array.isArray(value) &&
  Object.keys(value).length === 0;

const shouldSkipEmptyArray = (bVal, aVal) =>
  Array.isArray(bVal) &&
  bVal.length === 0 &&
  Array.isArray(aVal) &&
  aVal.length > 0;

const isNonArrayObject = (value) =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const mergeArrays = (aArr, bArr) => {
  if (!Array.isArray(aArr) || !Array.isArray(bArr)) return bArr;

  return bArr.map((bItem, i) => {
    const aItem = aArr[i];
    if (isNonArrayObject(bItem) && isNonArrayObject(aItem)) {
      return deepMerge(aItem, bItem);
    }
    if (shouldSkipEmptyArray(bItem, aItem)) return aItem;
    return bItem;
  });
};

const applyPriorityFields = (priorityMerged, aVal, tabKey) => {
  PRIORITY_FIELDS.forEach((priorityField) => {
    if (aVal[tabKey][priorityField] !== undefined) {
      if (!priorityMerged[tabKey]) priorityMerged[tabKey] = {};
      priorityMerged[tabKey][priorityField] = aVal[tabKey][priorityField];
    }
  });
};

const handleTabWiseDataPriority = (mergedNested, aVal, bVal) => {
  const priorityMerged = JSON.parse(JSON.stringify(mergedNested));
  ['parent', 'child'].forEach((tabKey) => {
    if (aVal[tabKey] && bVal[tabKey]) {
      applyPriorityFields(priorityMerged, aVal, tabKey);
    }
  });
  return priorityMerged;
};

const hasNestedChanged = (mergedNested, aVal) =>
  JSON.stringify(mergedNested) !== JSON.stringify(aVal);

const handleNestedObject = (key, bVal, aVal, result) => {
  const mergedNested = deepMerge(aVal, bVal);

  if (key === 'tabWiseData') {
    result[key] = handleTabWiseDataPriority(mergedNested, aVal, bVal);
    return;
  }

  if (hasNestedChanged(mergedNested, aVal)) {
    result[key] = mergedNested;
  }
};

const handleNonNestedValue = (key, bVal, aVal) => {
  if (PRIORITY_FIELDS.includes(key) && aVal !== undefined) return aVal;
  if (shouldSkipEmptyArray(bVal, aVal)) return aVal;

  if (Array.isArray(bVal) && Array.isArray(aVal)) {
    return mergeArrays(aVal, bVal);
  }

  return isNonArrayObject(bVal) ? deepMerge(aVal || {}, bVal) : bVal;
};

export const deepMerge = (a, b) => {
  if (typeof b !== 'object' || b === null) return a;

  if (Array.isArray(b)) {
    return b.length > 0 ? b : a;
  }

  const result = {...a};

  for (const key in b) {
    const bVal = b[key];
    const aVal = a?.[key];

    if (
      shouldSkipValue(bVal) ||
      isEmptyObject(bVal) ||
      shouldSkipEmptyArray(bVal, aVal)
    ) {
      continue;
    }

    if (isNonArrayObject(bVal) && aVal) {
      handleNestedObject(key, bVal, aVal, result);
    } else {
      result[key] = handleNonNestedValue(key, bVal, aVal);
    }
  }

  return result;
};
